import React from "react";
import axios from "axios";
import { generateRequestConfig } from "./constants";
import { ErrorAction, CsrfState } from "./interfaces";
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

export const fetchCsrfToken = async (
  setState: React.Dispatch<React.SetStateAction<CsrfState>>,
  setTimer?: (ms: number) => void  
) => {
  try {
    const requestConfigCSRF = generateRequestConfig(
      "get",
      "get_csrf_token",
      {},
      {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      }
    );

    const response = await axios(requestConfigCSRF);
    const { csrf_token, expires_in } = response.data;

    if (typeof csrf_token === "string" && csrf_token) {
      axios.defaults.headers.common["X-CSRF-TOKEN"] = csrf_token;
    }

    setState((prevState) => ({
      ...prevState,
      csrf_token,
    }));

    if (setTimer && expires_in) {
      setTimer(expires_in * 1000);  
    }
  } catch (error) {
    handleErrorForms(error);
  }
};




interface appInfo {
  _id?: string;
  appId?: string;
  name?: string;
  urlCallback?: string;
  [key: string]: any;
}

export const getAppInfo = async (setJsonData: (data: appInfo) => void) => {
  const appId = getIdApp();
  const ref = referer();

  try {
    
    const requestappInfo = generateRequestConfig(
      "get",
      "apps",
      {},
      { 
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
        
      },
      {
        key: appId,
        status: "enabled",
        items_per_page: 1,
      }
    );
    
    const response = await axios(requestappInfo);
    const dictionaryApp = Array.isArray(response.data.data) ? response.data.data[0] : response.data.data;
    const appData = {
      ...(dictionaryApp?.metadata || {}),
      _id: dictionaryApp?._id,
      appId: dictionaryApp?.key || appId,
    };

    setJsonData(appData);
    
      if(!ref && appData.urlCallback){
        Cookies.set('referer', appData.urlCallback , { expires: 7 });
      }

  } catch (error) {
    handleErrorForms(error);
  }
};

export function handleErrorForms(error: any): ErrorAction | null {
  try {
    const { response } = error;

    if (!response) {
      return error.message ? { message: error.message } : null;
    }

    const { status, data } = response;
    const errorFields = ["email", "password", "passwordRepeat", "code"] as const;

    for (const field of errorFields) {
      if (data.errors?.[field]) {
        return { message: data.errors[field][0], field };
      }
    }

    const baseResponse = { message: data.message, status };

    if (status === 301 && data.redirect) {
      return { ...baseResponse, redirect: data.redirect };
    }

    if ([401, 403, 404, 429, 500].includes(status)) {
      return baseResponse;
    }

    return null;
  } catch {
    return { message: "Something went wrong" };
  }
}
export const getDeviceId = () => {
  let deviceId = Cookies.get('deviceId')
  
  if(!deviceId ){
    deviceId = uuidv4()
    Cookies.set('deviceId', deviceId, { expires: 365 });
    return deviceId
  }else{
      
    return deviceId;
  }
}
export const resetEmailInviteKeyIfNeeded = () => {
  const pathname = window.location.pathname;
  const isLoginOrRegister = pathname.includes('/login') || pathname.includes('/register');
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");
  if (isLoginOrRegister && (!email || email === 'null')) {
    Cookies.remove('invite_key');
    Cookies.remove('email');
  }
};

export const getInviteKey = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let referer = urlParams.get("invite_key");
  let refererCookie = Cookies.get('invite_key')
  
  if(referer && referer!='null' ){
    Cookies.set('invite_key', referer);
  }else{
     if(refererCookie){
      referer = refererCookie;
     }
  }
  if(referer)
    return referer;
  else 
    return null;
};

export const getEmail = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let email = urlParams.get("email");
  let emailCookie = Cookies.get('email')
  
  if(email && email!='null' ){
    Cookies.set('email', email);
  }else{
    resetEmailInviteKeyIfNeeded();
     if(emailCookie){
      email = emailCookie;
     }
  }
  if(email)
    return email;
  else 
    return null;
};

export const getIdApp = () => {
  const configuredAppId = process.env.REACT_APP_GUN_APP_ID?.trim();
  if (configuredAppId) {
    Cookies.set('appId', configuredAppId, { expires: 7 });
    return configuredAppId;
  }

  const urlParams = new URLSearchParams(window.location.search);
  let referer = urlParams.get("appId");
  let refererCookie = Cookies.get('appId')
  
  if(referer && referer!='null' ){
    Cookies.set('appId', referer, { expires: 7 });
  }else{
     if(refererCookie){
      referer = refererCookie;
     }
  }
  if(referer)
    return referer;
  else 
    return null;
};

export const referer = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let referer = urlParams.get("referer");
  let refererCookie = Cookies.get('referer')
  
  if(referer && referer!='null' ){
    Cookies.set('referer', referer, { expires: 7 });
  }else{
     if(refererCookie){
      referer = refererCookie;
     }
  }
  if(referer)
    return referer;
  else 
    return null;
};


/**
 * Shared by Router.tsx (ProtectedRoute's forced redirect) and Home.tsx
 * (the background silent-login attempt on the public landing page) so
 * the two never drift the way pd.id.express and admin.id.express's
 * separate implementations once did. See
 * ~/.claude memory bug_password_special_char_regex.md for that lesson,
 * this is the same class of duplication risk applied to auth redirects.
 *
 * A prior silent-SSO attempt already failed (id.express appends this on
 * its own interaction_required redirect) -- retrying with prompt=none
 * again would just bounce back-and-forth forever between this app and
 * id.express. Strip it from the referer sent onward and fall back to an
 * interactive login instead of silent.
 */
export const getAuthRedirectUrl = (language: string) => {
  const appId = process.env.REACT_APP_GUN_APP_ID || getIdApp() || "a6729d6c-8ed9-4b63-81a8-6a0718247159";
  const authBaseUrl = (process.env.REACT_APP_GUN_AUTH_BASE_URL || "https://id.express").replace(/\/$/, "");
  const currentUrl = new URL(window.location.href);
  const silentSsoAlreadyFailed = currentUrl.searchParams.get("error") === "interaction_required";
  currentUrl.searchParams.delete("error");
  return `${authBaseUrl}/${language}/login/?appId=${encodeURIComponent(appId)}&referer=${encodeURIComponent(currentUrl.toString())}${silentSsoAlreadyFailed ? "" : "&prompt=none"}`;
};

export const getEmailFromParams = (): string | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email");

  // Decode the URL-encoded email parameter
  const decodedEmail = email ? decodeURIComponent(email) : null;

  // Validate the decoded email using a regular expression
  if (decodedEmail && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(decodedEmail)) {
    return decodedEmail;
  }
  return undefined;
};
